<template>
  <div class="cordel-inline">
    <form-input
      v-if="open"
      v-model="value"
      class="cordel-inline-input"
      size="small"
      :mask="mask"
    />

    <template v-else-if="!loading">
      {{ display }}
    </template>

    <form-button
      class="cordel-inline-button"
      :loading="loading"
      :icon="open ? 'check' : 'pen'"
      :disabled="outdated"
      size="small"
      @click="click"
    />
  </div>
</template>

<script>
  // eslint-disable-next-line import/no-extraneous-dependencies
  import * as FILTERS from '@/helpers/filters';

  import FormButton from '@cordel/components/Form/Button.vue';
  import FormInput from '@cordel/components/Form/Input.vue';

  export default {
    name: 'CordelInline',
    components: {
      FormButton,
      FormInput,
    },
    props: {
      current: {
        type: [String, Number],
        default: null,
      },
      outdated: {
        type: [String, Number],
        default: null,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      mask: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        open: false,
        value: this.formatted(),
      };
    },
    computed: {
      display() {
        return this.formatted();
      },
    },
    methods: {
      formatted() {
        if (this.mask) {
          return FILTERS[this.mask.type](this.current);
        }

        return this.current;
      },
      click() {
        if (this.open) {
          if (this.value !== this.temporary) {
            this.$emit('submit', this.value);
          }

          this.value = null;
        }

        this.open = !this.open;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-inline {
    align-items: center;
    color: var(--cordel-legacy-color-constant-dark);
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
  }

  .cordel-inline-input {
    flex: 0 0 auto;
  }

  .cordel-inline-button {
    margin-left: var(--cordel-legacy-spacing-xxxs);
  }
</style>
